import DataType from '@opsbase/lib-datatype/DataType';
import doNothing from '@opsbase/lib-general/utils/doNothing';
import i18n from '@opsbase/lib-i18n';
import Palette from '@opsbase/lib-palette';
import useOpDefinitionAssign from '@opsbase/react-gql-hooks/opdefinition/useOpDefinitionAssign';
import useOpDefinitionPlaces from '@opsbase/react-gql-hooks/opdefinition/useOpDefinitionPlaces';
import DataPill from '@opsbase/web-chips/DataPill';
import useCss from '@opsbase/web-css';
import OpDefinitionChooser from '@opsbase/web-data-choosers/OpDefinitionChooser';
import OpDefPlaceChooser from '@opsbase/web-data-choosers/OpDefPlaceChooser';
import SPTChooser from '@opsbase/web-data-choosers/SPTChooser';
import Dialog from '@opsbase/web-dialogs/Dialog';
import DialogSize from '@opsbase/web-dialogs/Dialog/DialogSize';
import Horizontal from '@opsbase/web-layout/Horizontal/Horizontal';
import Pane from '@opsbase/web-layout/Pane';
import Vertical from '@opsbase/web-layout/Vertical';
import useNav from '@opsbase/web-nav/useNav';
import useParams from '@opsbase/web-nav/useParams';
import useNotificationActions from '@opsbase/web-notification/useNotificationActions';
import { TimeDiffPicker } from '@opsbase/web-op-scheduler/OpScheduleEditor/TimeDiffPicker';
import { DatePicker } from '@opsbase/web-pickers/DatePicker';
import TimePicker from '@opsbase/web-pickers/DatePicker/TimePicker';
import TextFieldWithStateAndBlur from '@opsbase/web-textfield/TextFieldWithStateAndBlur';
import Button from '@opsbase/web-ui/Button';
import FieldSet from '@opsbase/web-ui/FieldSet/FieldSet';
import Radio from '@opsbase/web-ui/Radio';
import RadioGroup from '@opsbase/web-ui/RadioGroup';
import Text from '@opsbase/web-ui/Text';
import moment from 'moment-timezone';
import React, { useCallback, useEffect, useState } from 'react';
const makeMyClasses = () => ({
    dataPill: {
        marginTop: 8,
        border: `1px solid ${Palette.LavendarGrey.main}`,
        backgroundColor: Palette.White.main,
        height: 36,
    },
});
export function OpDefinitionAssignDialog() {
    var _a, _b, _c;
    const { opDefinition, staff } = useParams();
    const { raise } = useNotificationActions();
    const { goBack } = useNav();
    const [opDefs, setOpDefs] = useState(opDefinition ? [opDefinition] : []);
    const [title, setTitle] = useState();
    const [completeBy, setCompleteBy] = useState(moment().add(1, 'day'));
    const [place, setPlace] = useState([]);
    const [allStaff, setAllStaff] = useState(false);
    const [spt, setSPT] = useState([]);
    const [sptStaff, setSPTStaff] = useState(staff ? [staff.id] : []);
    const [sptPositions, setSPTPositions] = useState([]);
    const [sptTeams, setSPTTeams] = useState([]);
    const [busy, setBusy] = useState(false);
    const assignOpDefinition = useOpDefinitionAssign();
    const selectedOpDef = opDefs === null || opDefs === void 0 ? void 0 : opDefs[0];
    const myCss = useCss(makeMyClasses);
    const [sel, setSel] = useState('any');
    const isAny = sel === 'any';
    const isAll = sel === 'all';
    const [whenCanStart, setWhenCanStart] = useState(60);
    const [whenCanView, setWhenCanView] = useState(480);
    const visibleInvalid = whenCanStart > whenCanView;
    useEffect(() => {
        setTitle((selectedOpDef === null || selectedOpDef === void 0 ? void 0 : selectedOpDef.title) || '');
    }, [selectedOpDef]);
    const { data: places } = useOpDefinitionPlaces({
        variables: { id: selectedOpDef === null || selectedOpDef === void 0 ? void 0 : selectedOpDef.id, staffId: staff === null || staff === void 0 ? void 0 : staff.id, showMineOnly: true },
        skip: !(selectedOpDef === null || selectedOpDef === void 0 ? void 0 : selectedOpDef.id),
    });
    useEffect(() => {
        if ((places === null || places === void 0 ? void 0 : places.length) === 1)
            setPlace(places);
    }, [places]);
    const handleAssign = useCallback(() => {
        setBusy(true);
        raise(assignOpDefinition({
            id: selectedOpDef === null || selectedOpDef === void 0 ? void 0 : selectedOpDef.id,
            placeId: place[0].id,
            staff: sptStaff,
            positions: sptPositions,
            teams: sptTeams,
            title,
            completeBy,
            whenCanStart,
            whenCanView,
            allStaff,
            allSelected: sel === 'all',
        }), i18n.t('op-assigned-successfully'))
            .then(goBack)
            .catch(doNothing);
    }, [
        raise,
        assignOpDefinition,
        selectedOpDef,
        place,
        sptStaff,
        sptPositions,
        sptTeams,
        title,
        completeBy,
        whenCanStart,
        whenCanView,
        allStaff,
        sel,
        goBack,
    ]);
    const handleChangePlace = useCallback(v => setPlace(v), []);
    const handleChangeOpDef = useCallback(v => setOpDefs(v), []);
    const handleSelectAllStaff = useCallback(v => {
        setAllStaff(v);
        setSPT([]);
        setSPTStaff([]);
        setSPTTeams([]);
        setSPTPositions([]);
    }, []);
    const handleChangeSPT = useCallback(v => {
        setAllStaff(false);
        setSPT(v);
        setSPTStaff(v.filter(s => s.type === 'staff').map(s => s.id));
        setSPTPositions(v.filter(s => s.type === 'position').map(s => s.id));
        setSPTTeams(v.filter(s => s.type === 'team').map(s => s.id));
    }, []);
    const handleChangeTitle = useCallback(v => setTitle(v), []);
    const handleChangeCompleteBy = useCallback(v => setCompleteBy(v), []);
    const handleChangeStart = useCallback(v => setWhenCanStart(v), []);
    const handleChangeView = useCallback(v => setWhenCanView(v), []);
    const canStart = (selectedOpDef === null || selectedOpDef === void 0 ? void 0 : selectedOpDef.id) &&
        (place === null || place === void 0 ? void 0 : place.length) &&
        ((sptStaff === null || sptStaff === void 0 ? void 0 : sptStaff.length) || allStaff || (sptTeams === null || sptTeams === void 0 ? void 0 : sptTeams.length) || (sptPositions === null || sptPositions === void 0 ? void 0 : sptPositions.length));
    return (React.createElement(Dialog, { size: DialogSize.X800_Y550, title: i18n.t('assign-op'), buttonsRight: React.createElement(Button, { disabled: !canStart || busy, color: Palette.positive, label: i18n.t('assign-op'), onClick: handleAssign }) },
        React.createElement(Vertical, { padding: true, gutter: true },
            !opDefinition && (React.createElement(OpDefinitionChooser, { value: opDefs, filters: { staff: sptStaff, team: sptTeams, position: sptPositions }, onChange: handleChangeOpDef })),
            !!opDefinition && (React.createElement(Pane, null,
                React.createElement(DataPill, { classes: { root: myCss.dataPill }, type: DataType.OPDEFINITION, value: opDefinition === null || opDefinition === void 0 ? void 0 : opDefinition.title }))),
            !!selectedOpDef && (places === null || places === void 0 ? void 0 : places.length) > 1 && (React.createElement(OpDefPlaceChooser, { value: place, onChange: handleChangePlace, placesList: places, opDefinition: selectedOpDef === null || selectedOpDef === void 0 ? void 0 : selectedOpDef.id })),
            !!selectedOpDef && (places === null || places === void 0 ? void 0 : places.length) === 1 && (React.createElement(Pane, null,
                React.createElement(DataPill, { classes: { root: myCss.dataPill }, type: DataType.PLACE, value: (_a = place === null || place === void 0 ? void 0 : place[0]) === null || _a === void 0 ? void 0 : _a.title }))),
            !!(place === null || place === void 0 ? void 0 : place.length) && !staff && (React.createElement(Pane, { paddingY: true },
                React.createElement(FieldSet, { label: i18n.t('assignto') },
                    React.createElement(RadioGroup, { value: sel, onChange: setSel },
                        React.createElement(Vertical, null,
                            React.createElement(Horizontal, { justify: "flex-start", gutter: true, centered: true },
                                React.createElement(Radio, { value: "any", checked: isAny }),
                                React.createElement(Text, { color: isAny && Palette.GoodOldBlue }, i18n.t('any-staff-selected'))),
                            isAny && (React.createElement(SPTChooser, { multi: true, value: spt, filters: {
                                    place: place.map(p => p.id),
                                    opDefinition: [selectedOpDef === null || selectedOpDef === void 0 ? void 0 : selectedOpDef.id],
                                    enabled: ['TRUE'],
                                }, onChange: handleChangeSPT })),
                            React.createElement(Horizontal, { justify: "flex-start", gutter: true, centered: true },
                                React.createElement(Radio, { value: "all", checked: isAll }),
                                React.createElement(Text, { color: isAll && Palette.GoodOldBlue }, 'All staff selected')),
                            isAll && (React.createElement(SPTChooser, { multi: true, value: spt, filters: {
                                    place: place.map(p => p.id),
                                    opDefinition: [selectedOpDef === null || selectedOpDef === void 0 ? void 0 : selectedOpDef.id],
                                    enabled: ['TRUE'],
                                }, onChange: handleChangeSPT, allSelectedLabel: 'All Staff', allSelectable: true, allSelected: allStaff, onSelectAll: handleSelectAllStaff }))))))),
            !!staff && (React.createElement(Pane, null,
                React.createElement(DataPill, { classes: { root: myCss.dataPill }, type: DataType.STAFF, value: staff === null || staff === void 0 ? void 0 : staff.title, avatarUrl: staff === null || staff === void 0 ? void 0 : staff.avatarUrl }))),
            React.createElement(TextFieldWithStateAndBlur, { value: title, white: true, onChange: handleChangeTitle, label: i18n.t('title') }),
            !!selectedOpDef && place.length && (React.createElement(React.Fragment, null,
                React.createElement(Pane, null,
                    React.createElement(Text, { variant: "h2" }, "Due"),
                    React.createElement(Horizontal, { justify: 'flex-start', gutter: true },
                        React.createElement(DatePicker, { white: true, timezone: (_b = place[0]) === null || _b === void 0 ? void 0 : _b.timezone, noMargin: true, value: completeBy, onChange: handleChangeCompleteBy }),
                        React.createElement(TimePicker, { white: true, timezone: (_c = place[0]) === null || _c === void 0 ? void 0 : _c.timezone, noMargin: true, value: completeBy, onChange: handleChangeCompleteBy }))),
                React.createElement(Pane, null,
                    React.createElement("ul", null,
                        React.createElement("li", null,
                            React.createElement(Text, null,
                                "Can be started",
                                ' ',
                                React.createElement(TimeDiffPicker, { noMargin: true, noBorder: true, value: whenCanStart, onChange: handleChangeStart }),
                                ' ',
                                "before it is due")),
                        React.createElement("li", null,
                            React.createElement(Text, { color: visibleInvalid ? 'error' : undefined },
                                "Visible in To-Do list",
                                ' ',
                                React.createElement(TimeDiffPicker, { noMargin: true, noBorder: true, value: whenCanView, onChange: handleChangeView }),
                                ' ',
                                "before it is due")))))))));
}
export default OpDefinitionAssignDialog;
